import { ViewModel,View, ObservableArray, ViewModelMessage } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { BpmnEditorViewModel } from "./bpmnEditor/bpmnEditor-viewModel";
import { DataModelDesignerViewModel } from "./dataModelDesigner/dataModelDesigner-viewModel";
import  { ProcessDefinitionView } from "./processDefinition-view"
import { ProcessFormsViewModel } from "./processForms/processForms-viewModel";
import { ShowMessageBoxMessage } from "src/binder/uiPatterns/mvvm/viewmodel";

export class ProcessDefinitionViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'System Builder';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.processes = ObservableArray.create<singleProcess>();
        
        let bpmnEditor = new BpmnEditorViewModel(this);
        let dataModelEditor = new DataModelDesignerViewModel(this);
        this.forms = new ProcessFormsViewModel(this);
        this.processDefinitionParts = ObservableArray.create<IEditorPart>();
        this.processDefinitionParts.update(...[bpmnEditor,dataModelEditor,this.forms]);
        this.selectedDefinitionPart = bpmnEditor;

        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new ProcessDefinitionView();
    }
    public getTypeId(): string {
        return "VM-CB80AE60-49CD-48FB-A9C4-A1E615B7918C"
    }
    private forms:ProcessFormsViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set processes(v: ObservableArray<singleProcess>) { this._processes = v; } public get processes(): ObservableArray<singleProcess> { return this._processes;} private _processes: ObservableArray<singleProcess>;
    public set selectedProcess(v: singleProcess) { 
        if(this.selectedDefinitionPart && this.selectedDefinitionPart.hasUnsavedChanges()){
            let result = confirm('Do you want to save data?');
            if(result==true)
                return;
        }
        this._selectedDefinitionPart?.dispose();
        this._selectedProcess = v; 
        this.newProcessName = v?.name ?? "";
        this.selectedDefinitionPart.loadByProcessId(v.id);
    } public get selectedProcess(): singleProcess { return this._selectedProcess;} private _selectedProcess: singleProcess;
    public set newProcessName(v: string) { this._newProcessName = v; } public get newProcessName(): string { return this._newProcessName;} private _newProcessName: string;
    
    public set processDefinitionParts(v: ObservableArray<IEditorPart>) { this._processDefinitionParts = v; } public get processDefinitionParts(): ObservableArray<IEditorPart> { return this._processDefinitionParts;} private _processDefinitionParts: ObservableArray<IEditorPart>;
    public set selectedDefinitionPart(v: IEditorPart) { 
        if(this._selectedDefinitionPart && this._selectedDefinitionPart.hasUnsavedChanges()){
            let result = confirm('Do you want to save data?');
            if(result==true)
                return;
        }
        this._selectedDefinitionPart?.dispose();
        this._selectedDefinitionPart = v; 
        if(this.selectedProcess)
            this.selectedDefinitionPart.loadByProcessId(this.selectedProcess.id);
    
    } public get selectedDefinitionPart(): IEditorPart { return this._selectedDefinitionPart;} private _selectedDefinitionPart: IEditorPart;
    public handleMessage(message: ViewModelMessage) {
        if(message instanceof FindCurrentEditingProcessFormNameMessage){
            let formName = this.forms.selectedForm?.name ?? "";
            return new FindCurrentEditingProcessFormNameResult(this.selectedProcess.name,formName)
        }else if(message instanceof ShowMessageBoxMessage){
            message.direction = "ltr";
            return super.handleMessage(message);
        }else{
            return super.handleMessage(message);
        }
    }
    async refresh(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/BpmsRawDataServices/GetAllProcesses',{});
            this.processes.update(...result.Processes.map((x,i)=>{
                let r = new singleProcess(this);
                r.id = x.Id;
                r.index = i+1;
                r.name = x.Name;
                return r;
            }));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async createNewProcess(){
        try {
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/BpmsRawDataServices/CreateProcess',{
                Name:this.newProcessName
            });
            this.messageBoxConfirmSuccess('Workflow Created Successfully','New Workflow');
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async updateProcessName(){
        try {
            this.isLoading = true;
            let result = await this.messageBoxWarningYesNo("Do you want to rename workflow?","Renaming");
            if(result=='no')
                return;
            await ServerConnection.callServer('/Complex/BpmsRawDataServices/ChangeProcessName',{
                ProcessId : this.selectedProcess.id,
                NewName:this.newProcessName
            });
            this.messageBoxConfirmSuccess('Renaming done successfully','Renaming');
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    async deleteProcess(){
        try {
            this.isLoading = true;
            let result = await this.messageBoxDangerYesNo("Are you sure?","Delete");
            if(result=='no')
                return;
            await ServerConnection.callServer('/Complex/BpmsRawDataServices/DeleteProcess',{
                ProcessId : this.selectedProcess.id,
            });
            this.messageBoxConfirmSuccess('Delete finished successfully.','Delete');
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}


export class singleProcess extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
}

export interface IEditorPart{
    loadByProcessId(processId:string);
    get title():string;set title(v:string);
    hasUnsavedChanges():boolean;
    dispose();
} 

export class FindCurrentEditingProcessFormNameMessage extends ViewModelMessage{

}
export class FindCurrentEditingProcessFormNameResult{
    constructor(processName:string,formName:string) {
        this.ProcessName = processName;
        this.FormName = formName;         
    }
    public ProcessName:string;
    public FormName:string;
}